import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PhotosContent.module.css';
import PhotosContentItem from './PhotosContentItem';
import { getOverFiveKg } from '../store/photos';

const PhotosContent2 = () => {
  //const dispatch = useDispatch();
  //const datax = getOverFiveKg();
  //console.log(datax);

  //return null;

  const { data } = useSelector((state) => state.photos);
  
  const overFiveKg = data?.data.filter(({ id }) => id >= 1);
 
  const transformPound = overFiveKg?.map((photo) => ({
    ...photo,
    peso: Math.floor(photo.peso * 2.2),
  }));

  console.log('photscontent2');
  console.log(data);
  //console.log(state.data?.data);
  return (
    <ul className={styles.list}>
      {transformPound?.map((photo,index) => (
        <li key={index} className={`${styles.item} anime`}>
          <img src={photo.src} alt={photo.title} className={styles.img} />
          <PhotosContentItem id={photo.id} src={photo.src} title={photo.title}/>
          <span className={styles.acessos}>{photo.acessos}</span>
        </li>
      ))}
    </ul>
  );
};

export default PhotosContent2;
